import { getAPI } from "./Networking";
import dayjs from "dayjs";
import {
  EmployeeCountsResponse,
  EmployeesListResponse,
  HrmsEmployeeListParams,
  HrmsSyncEventsListParams,
  HrmsSyncEventsResponse,
} from "../models/Employees/HrmsEmployee";

export default class HrmsAPI {
  getEmployees = async (
    params: HrmsEmployeeListParams,
  ): Promise<EmployeesListResponse> => {
    const queryParams = new URLSearchParams();
    if (params.customer_id > 0) {
      queryParams.append("customer_id", String(params.customer_id));
    }
    queryParams.append("page_no", String(params.page_no));
    queryParams.append("limit", String(params.limit));
    if (params.search_text) queryParams.append("search_text", params.search_text);
    if (params.employment_status) {
      queryParams.append("employment_status", params.employment_status);
    }
    if (params.active !== undefined) {
      queryParams.append("active", params.active ? "true" : "false");
    }
    if (params.inactive !== undefined) {
      queryParams.append("inactive", params.inactive ? "true" : "false");
    }
    if (params.new_employees !== undefined) {
      queryParams.append("new_employees", params.new_employees ? "true" : "false");
    }
    if (params.new_days !== undefined) {
      queryParams.append("new_days", String(params.new_days));
    }

    const response = await getAPI(`/v5/employees?${queryParams.toString()}`);
    return response as EmployeesListResponse;
  };

  getEmployeeCounts = async (
  ): Promise<EmployeeCountsResponse> => {
    // Global endpoint already uses backend default for new_days.
    const response = await getAPI(`/v5/employees/get-counts-global`);
    return response as EmployeeCountsResponse;
  };

  getSyncEvents = async (
    params: HrmsSyncEventsListParams,
  ): Promise<HrmsSyncEventsResponse> => {
    const queryParams = new URLSearchParams();
    const customerId = String(params.customerId ?? params.customer_id ?? "").trim();
    if (customerId) {
      queryParams.append("customerId", customerId);
    }
    const searchText = String(params.search_text ?? "").trim();
    if (searchText) {
      queryParams.append("search_text", searchText);
    }
    if (params.start_date) {
      const startDate = dayjs(params.start_date, "YYYY-MM-DD")
        .utc()
        .format("YYYY-MM-DD HH:mm:ss");
      queryParams.append("start_date", startDate);
    }
    if (params.end_date) {
      const endDate = dayjs(params.end_date, "YYYY-MM-DD")
        .add(1, "day")
        .utc()
        .format("YYYY-MM-DD HH:mm:ss");
      queryParams.append("end_date", endDate);
    }
    queryParams.append("page", String(params.page));
    queryParams.append("limit", String(params.limit));

    const response = await getAPI(
      `/v5/getknit/sync-events?${queryParams.toString()}`,
    );
    return response as HrmsSyncEventsResponse;
  };
}
